export const APIs = {
    API: "api/",
    LOGIN: "login",
    EMAIL_VERIFICATION: "login/verify-email",
    SSO_LOGIN: "sso/token-login?Token=",
    AUTH_LOGIN: "auth",
    REFRESH_USERTOKEN: "refreshtoken",
    GET_DOMAIN_CONFIGURATIONS: "domains/configurations",
    ISCOMPANYAVAILABLE: "domains/availability?brandingColors=true&DomainUrl=",
    PRIVACY_POLICY: "privacy-policies/sessions/{SessionId}",
    COUNTRY_LIST: "helper/countries",
    JOIN_MEETING: "sessions/{SessionId}/join",
    END_CALL: "sessions/{SessionId}/call-end",
    DISCONNECT_USER_REMOTELY: "sessions/{RoomSid}/participants/{ParticipantSid}",
    SEND_DEVICE_INFORMATION: "sessions/{SessionId}/device",
    SURVEY_RATTING: "survey/standard/rating",
    SURVEY_COMMENT: "survey/standard/comment",
    CREATE_NOTE: "sessions/{SessionId}/notes",
    UPDATE_NOTE: "sessions/{SessionId}/notes/{NoteId}",
    DELETE_NOTE: "sessions/{SessionId}/notes/{NoteId}",
    ADD_BOOKMARKS: "sessions/{SessionId}/bookmarks",
    TAG_BOOKMARKS: "v1/Bookmark/Analysis",
    INVITE_PARTICIPANT: "sessions/{SessionId}/ongoing-invitations",
    STORE_CHAT_DATA: "v1/Session/{SessionId}/Chat",
    STORE_OCR_DATA: "v1/Session/{SessionId}/OCR",
    UPLOAD_SESSION_FILE: "v1/Session/UploadFile",
    UPLOAD_TEMP_FILE: "v1/Misc/UploadSessionFile",
    START_RECORDING: "sessions/{SessionId}/start-recording",
    STOP_RECORDING: "sessions/{SessionId}/stop-recording",
    DELETE_IMAGE: "v1/Session/Images/",
    SESSION_STATS: "SessionStats/Add",
    ALERT_MESSAGE: "alert",
    START_LIVE_CAPTION: "sessions/{SessionId}/start-transcription",
    STOP_LIVE_CAPTION: "sessions/{SessionId}/stop-transcription",
    STORE_TRANSCRIPTION_DATA: "v1/Session/UploadTranscription",
};
